import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index',
	},
	component: layoutHeaderAside,
	children: [
		{
			path: 'ProfitReport1',
			name: 'ProfitReport1',
			meta: {
				title:'利润统计',
				i18n:'ProfitReport',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Report/ProfitReport1/ProfitReport1')
		},
		{
			path: 'BicycleFqSaleExpiredInfo',
			name: 'BicycleFqSaleExpiredInfo',
			meta: {
				title:'月度逾期分析',
				i18n:'BicycleFqSaleExpiredInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Report/BicycleFqSaleExpiredInfo/BicycleFqSaleExpiredInfo')
		},
		{
			path: 'MoneyVerifyReport',
			name: 'MoneyVerifyReport',
			meta: {
				title:'财务凭证报表',
				i18n:'MoneyVerifyReport',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Report/MoneyVerifyReport1/MoneyVerifyReport1')
		},
		{
			path: 'BicycleFqSaleInfo',
			name: 'BicycleFqSaleInfo',
			meta: {
				title:'整车分期销售单',
				i18n:'BicycleLoanSale',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Project/BicycleFqSaleInfo/BicycleFqSaleInfo')
		},
		{
			path: 'BicycleQkSaleInfo',
			name: 'BicycleQkSaleInfo',
			meta: {
				title:'整车全款销售单',
				i18n:'BicycleFullSale',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Project/BicycleQkSaleInfo/BicycleQkSaleInfo')
		},
		{
			path: 'MoneyVerifyInfo',
			name: 'MoneyVerifyInfo',
			meta: {
				title:'财务凭证管理',
				i18n:'MoneyVerifyInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Finance/MoneyVerifyInfo/MoneyVerifyInfo')
		},
		{
			path: 'ItemQkSaleInfo',
			name: 'ItemQkSaleInfo',
			meta: {
				title:'配件全款销售单',
				i18n:'ItemFullSale',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Project/ItemQkSaleInfo/ItemQkSaleInfo')
		},
		{
			path: 'AssembleInfo',
			name: 'AssembleInfo',
			meta: {
				title:'组装与拆分',
				i18n:'AssembleInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Project/AssembleInfo/AssembleInfo')
		},
		{
			path: 'TransportInfo',
			name: 'TransportInfo',
			meta: {
				title:'库存调拨单',
				i18n:'TransportInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Project/TransportInfo/TransportInfo')
		},
		{
			path: 'StoreReport',
			name: 'StoreReport',
			meta: {
				title:'库存统计',
				i18n:'StoreReport',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Report/StoreReport/StoreReport')
		},
		{
			path: 'PurchaseInfo',
			name: 'PurchaseInfo',
			meta: {
				title:'采购入库单',
				i18n:'PurchaseInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Project/PurchaseInfo/PurchaseInfo')
		},
		{
			path: 'BicycleInfo',
			name: 'BicycleInfo',
			meta: {
				title:'整车档案',
				i18n:'BicycleInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/BicycleInfo/BicycleInfo')
		},
		{
			path: 'ItemInfo',
			name: 'ItemInfo',
			meta: {
				title:'配件档案',
				i18n:'ItemInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/ItemInfo/ItemInfo')
		},
		{
			path: 'StoreInfo',
			name: 'StoreInfo',
			meta: {
				title:'店铺档案',
				i18n:'StoreInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/Basic/StoreInfo/StoreInfo')
		},
		{
			path: 'NoticeInfo',
			name: 'NoticeInfo',
			meta: {
				title:'公告管理',
				i18n:'NoticeInfo',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/NoticeInfo/NoticeInfo')
		},


		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				title:'首页',
				i18n:'Home',
				auth: true
			},
			component: _import('system/index')
		},
		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		},
		// 下面都是我的页面：
		{
			path: 'UserInfo',
			name: 'UserInfo',
			meta: {
				title:'用户及权限',
				i18n:'UserManage',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/UserInfo/UserInfo')
		}, {
			path: 'UpdateLogInfo',
			name: 'UpdateLogInfo',
			meta: {
				title:'更新日志',
				i18n:'UpdateLog',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/UpdateLogInfo/UpdateLogInfo')
		}, {
			path: 'MenuInfo',
			name: 'MenuInfo',
			meta: {
				title:'菜单设置',
				i18n:'MenuSettings',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/MenuInfo/MenuInfo')
		},



	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
